<template>
<v-card flat >
  <v-card-title class='subheading' >
    <v-btn small icon :loading='treatmentLogsRequest.loading' @click='get' >
      <v-icon small >replay</v-icon>
    </v-btn>
    {{ $t('logs.title') }}
    <v-spacer></v-spacer>
    <v-btn outline outlined
      @click='touchers.editform++;selectedLog={};dialogs.add=true;'
      small flat color='primary' class='ma-0' >
      <v-icon>add</v-icon> {{ $t('buttons.add') }}
    </v-btn>
  </v-card-title>
  <v-list v-if='treatmentLogs && treatmentLogs.length > 0' dense three-line >
      <v-progress-linear
        v-if='changeLogsRequest.loading'
        indeterminate class='pa-0 ma-0' :height="3" >
      </v-progress-linear>
      <v-progress-linear
        v-if='treatmentLogsRequest.loading'
        indeterminate class='pa-0 pa-0' :height="3" >
      </v-progress-linear>
      <template v-for='(log, index) in treatmentLogs' >
        <template v-if='isNewPractitioner(log, index, treatmentLogs)' >
          <v-subheader
            class='grey lighten-4 overline' >
              {{ getPractitionerById(log.practitioner).full_name }}
          </v-subheader>
          <v-divider/>
        </template>
        <treatment-log-list-item
          @selected='selectedLog=log;dialogs.add=true'
          @clicked:delete='dodelete'
          :key='log.id'
          :item='log' >
        </treatment-log-list-item>
      </template>
  </v-list>
  <template v-if='treatmentLogs && treatmentLogs.length === 0 && !treatmentLogsRequest.loading' >
    <v-divider></v-divider>
    <v-card flat >
        <v-card-title>
          {{ $t('zerocurrentresults') }}
          <v-spacer></v-spacer>
          <v-btn
            href='https://www.loom.com/share/f26d5537be0540f7bd8fc82c61b9b6f6'
            target='_blank'
            color='primary' small outline outlined >
              Watch a quick video tutorial
              <v-icon class='ml-2' small >open_in_new</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <h3 class='subheader' >What is this?</h3>
          <p>
            Client history is a place for you to manually record treatment of a patient (ICD-10 and treatment codes) over time.
            You can record diagnosis without needing to add it to your appointments and invoices.
          </p>
          <strong>Benefits of keeping a manual treatment record</strong>
          <ul>
            <li>Track information from other practitioners (e.g.: referring practitioner diagnosis)</li>
            <li>Track diagnosis and treatment other than what you need to bill for</li>
            <li><v-icon color='amber' small>flash_on</v-icon><strong>Automation:</strong> AppointmentGuru can automatically add codes to new appointments for you</li>
          </ul>
          <p class='mt-3'>
            <strong>AppointmentGuru</strong> will also automatically keep a record of the codes you have used on appointments.
            You can access this information from the
            <strong>{{ $t('tabs.usage') }}</strong>
            tab
          </p>
        </v-card-text>
    </v-card>
  </template>
  <v-dialog v-model='dialogs.add' :fullscreen='$vuetify.breakpoint.xs' >
    <v-toolbar dense :color='themeColor' >
      <v-spacer></v-spacer>
      <v-btn @click='dialogs.add = false' icon dark ><v-icon dark>close</v-icon></v-btn>
    </v-toolbar>
    <request-status :request='changeLogsRequest' ></request-status>
    <client-treatment
      @save='save'
      v-model="selectedLog"
      :loading='changeLogsRequest.loading'
      :touch='touchers.editform' ></client-treatment>
  </v-dialog>
</v-card>
</template>
<script>
import ClientTreatment from '../ClientTreatment.vue'
import TreatmentLogListItem from '@/components/medicalaid/TreatmentLogListItem.vue'
import {mapGetters} from 'vuex'

export default {
  name: 'TreatmentLogs',
  components: { ClientTreatment, TreatmentLogListItem },
  props: {
    relationshipId: { required: true }
  },
  data () {
    return {
      resource: 'practitioner.v2.clients.treatment',
      requests: {
        change: 'change-treatment-log',
        get: 'get-treatment-log'
      },
      touchers: {
        editform: 1
      },
      dialogs: {
        add: false
      },
      selectedLog: {}
    }
  },
  watch: {
    relationshipId: {
      immediate: true,
      handler () {
        this.get()
      }
    },
    touch () {
      this.get()
    },
    changeLogsRequestStatus () {
      if (this.changeLogsRequestStatus === 201 || this.changeLogsRequestStatus === 200) {
        this.get()
        this.touchers.editform++
        this.dialogs.add = false
      }
      if (this.changeLogsRequestStatus === 204) {
        this.get()
      }
    }
  },
  computed: {
    ...mapGetters(['getPractitionerById']),
    treatmentLogs () {
      return this.getObjectPath(this.treatmentLogsRequest, 'result.data.results', [])
    },
    treatmentLogsRequest () {
      return this.$store.getters.getRequestById(this.requests.get, true)
    },
    changeLogsRequest () {
      return this.$store.getters.getRequestById(this.requests.change, true)
    },
    changeLogsRequestStatus () {
      return this.changeLogsRequest.status
    }
  },
  methods: {
    get () {
      let params = {
        'relationship_id': this.relationshipId
      }
      this.$appointmentguru
        .resource(this.resource)
        .id(this.requests.get)
        .list(params)
    },
    isNewPractitioner (log, index, treatmentLogs) {
      if (index === 0) { return true }
      let lastLog = treatmentLogs[index - 1]
      if (log.practitioner === lastLog.practitioner) { return false }
      return true
    },
    save (log) {
      log.relationship = this.relationshipId
      let data = JSON.stringify(log)
      if (log.id) {
        this.$appointmentguru
          .resource(this.resource)
          .id(this.requests.change)
          .save(log.id, data)
      } else {
        this.$appointmentguru
          .resource(this.resource)
          .id(this.requests.change)
          .create(data)
      }
    },
    dodelete (log) {
      this.$appointmentguru
        .resource(this.resource)
        .id(this.requests.change)
        .delete(log.id)
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Diagnosis and treatment history',
        timesUsed: 'Never used | Used once | Used {count} times',
        buttons: {
          add: 'Add',
          addwithdescription: 'Add an item'
        },
        tabs: {
          usage: 'Code usage'
        },
        zerocurrentresults: 'No treatment logs found',
        logs: {
          title: 'Diagnosis and treatment history',
          current: 'Current diagnosis and treatment',
          historical: 'Codes previously used',
          historicalsubtitle: '(sorted by last time used)',
          count: 'Never used|Used once|Used twice|Used {n} times',
          summary: '{n} codes used | {n} code used since {from} | {n} codes used since {from}',
          searchinfo: 'Searching for {string}',
          lastseen: 'Last seen: {date}'
        },
        help: 'Treatment logs help you keep track of diagnosis and treatments for a patient over time. You can also use them to speed up your invoicing by automatically adding current treatment codes to new appointments for this patient'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// TreatmentLogs.vue?3051c6dc